import { getLastFinancialYear } from "@syla/shared/helpers/financialYear";
import { useGlobalVariablesStore } from "./globalVariablesStore";

/**
 * The financial year currently selected by the user on the Tax Reports page,
 * defaulting to the last completed financial year if none is selected.
 */
export const useSelectedFinancialYear = () => {
  const selectedFinancialYear = useGlobalVariablesStore(
    (state) => state.selectedFinancialYear,
  );

  return selectedFinancialYear?.value ?? getLastFinancialYear();
};
